// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as projectService from "../../../services/companyData/projectService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const ProjectsListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadTableData();
    }, [])

    const loadTableData = () => {
        projectService.getProjects().then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(() => setLoading(false));
    }

    const deleteProject = (id) => {
        projectService.deleteProject(id).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            hideConfirmModal();
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <Link
                                to={{
                                    pathname: "/company-data/project/edit/" + data[dataIndex].id,
                                }}
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                            >
                                Edit
                            </Link> &nbsp;
                            <button
                                onClick={() => showConfirmModal({
                                    title: "Delete Project",
                                    text: "Are you sure you want to delete this project?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteProject(data[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                            >
                                Delete
                        </button>
                        </>
                    );
                }
            },

        },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectSubType",
            label: "Project Sub Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "name",
            label: "Project Name",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    return (
        <div className="row" >
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Projects
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Projects
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <Link
                                to="/company-data/project/edit/0"
                                to={{
                                    pathname: "/company-data/project/edit/0",
                                    state: { projectId: 0 }
                                }}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Add Project
                            </Link>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(ProjectsListingPage);